import React, { useMemo } from 'react';
import * as ReactBootstrap from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { IReducer } from '../../../../../../redux/configureStore';
import Frame from '../../../../../../shared/components/Frame';
import Wrapper from '../../../../../../shared/components/Wrapper';
import UnifiedReportV2 from './components/UnifiedReportV2';

function UnifiedReport() {
  const accountingAppContext = useSelector(
    (reducer: IReducer) => reducer.accountingAppV2
  );
  const loading = useMemo(() => {
    if (accountingAppContext.isLoading) {
      return (
        <Wrapper.Default margin="5% 0 5% 0" isActive>
          <ReactBootstrap.Spinner animation="border" />
        </Wrapper.Default>
      );
    }
    return <></>;
  }, [accountingAppContext.isLoading]);

  return (
    <>
      {loading}
      <Frame.Default isActive={accountingAppContext.isActive}>
        <Wrapper.Default width="100%" isActive>
          <UnifiedReportV2 />
        </Wrapper.Default>
      </Frame.Default>
    </>
  );
}

export default UnifiedReport;
